import { createStore } from "vuex";

export default createStore({
  state: {
    // 路由标识
    hasRoutes: false,
    editableTabsValue: "/admin/index",
    editableTabs: [
      {
        title: "首页",
        name: "/admin/index",
      },
    ],
  },
  getters: {},
  mutations: {
    ADD_TABS: (state, tab) => {
      // 检查即将进入的路由是否是后台路由
      const isBackendRoute = tab.path.startsWith("/admin");
      // 如果是后台路由，并且标签页中不存在该路径，则添加标签页
      if (
        isBackendRoute &&
        state.editableTabs.findIndex((e) => e.name === tab.path) === -1
      ) {
        state.editableTabs.push({
          title: tab.name,
          name: tab.path,
        });
      }
      // 定义menu点击后，tabs当前值
      state.editableTabsValue = tab.path;
    },
    RESET_TABS: (state) => {
      state.editableTabsValue = "/admin/index";
      state.editableTabs = [
        {
          title: "首页",
          name: "/admin/index",
        },
      ];
    },
    SET_ROUTES_STATE:(state,hasRoutes)=>{
      state.hasRoutes = hasRoutes
    }
    
  },
  actions: {},
  modules: {},
});
